@if (visible) {
    <div class="cookie-banner" role="region" [attr.aria-label]="'PROFILE.COOKIES' | translate">
        <p class="cookie-banner-text">
            {{ 'COOKIES.USAMOS_COOKIES_NECESARIAS_PARA_EL' | translate }}
            <a href="#" (click)="openPrivacy($event)">{{ 'COOKIES.MAS_INFORMACION' | translate }}</a>
        </p>
        <div class="cookie-banner-actions">
            <ion-button fill="clear" size="small" (click)="rejectAll()">{{ 'EVENT.RECHAZAR' | translate }}</ion-button>
            <ion-button fill="outline" size="small" (click)="openPreferences()">
                {{ 'COOKIES.PREFERENCIAS' | translate }}
            </ion-button>
            <ion-button size="small" (click)="acceptAll()">{{ 'COMMON.ACCEPT' | translate }}</ion-button>
        </div>
    </div>
}
